/**
 * sp-related-products.js
 * ------------------------------------------------------------
 * Async loader for the Sipfull related-products section.
 *
 * The main product section (sipfull-product.liquid /
 * sipfull-product-personalised.liquid) emits a placeholder element:
 *
 *   <div data-sp-related
 *        data-product-id="{{ product.id }}"
 *        data-recommendations-url="{{ routes.product_recommendations_url }}">
 *   </div>
 *
 * On DOMContentLoaded this script fetches Shopify's recommendations
 * endpoint, which renders sections/sipfull-related-products.liquid with
 * the `recommendations.products` array populated. We extract the
 * .sp-row--related element from the response and swap it into the
 * placeholder's position in the DOM.
 *
 * Replaces the previous `product.collections | first` approach
 * (PDP-conv-2026-05-30) which always picked a product's first-created
 * collection, making cross-sells feel irrelevant on non-motoring
 * products.
 *
 * Failure modes:
 *   - Network error / endpoint blocked → placeholder removed silently,
 *     leaving no related row (better than a broken empty row).
 *   - Recommendations returned empty → response contains no
 *     .sp-row--related element; placeholder is removed.
 *   - Multiple placeholders on page → all are processed, but
 *     typically there's only one per page.
 */
(function () {
  'use strict';

  function loadRelated(placeholder) {
    var productId = placeholder.dataset.productId;
    var baseUrl = placeholder.dataset.recommendationsUrl;
    if (!productId || !baseUrl) {
      placeholder.remove();
      return;
    }

    // limit=10 matches the previous collection-based render's 12-item
    // cap reasonably well — Shopify's recommendations engine typically
    // returns 4-10 high-relevance items.
    var url = baseUrl
      + '?section_id=sipfull-related-products'
      + '&product_id=' + encodeURIComponent(productId)
      + '&limit=10';

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Shopify wraps the section in <div class="shopify-section">.
        // We want the inner .sp-row--related (rendered by the section's
        // Liquid when recommendations.performed is true). If no
        // recommendations were returned, the section renders empty and
        // there's no .sp-row--related — fall through to placeholder
        // removal below.
        var related = doc.querySelector('.sp-row--related');
        if (related) {
          placeholder.replaceWith(related);
        } else {
          placeholder.remove();
        }
      })
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[sp-related-products] fetch failed:', err);
        }
        placeholder.remove();
      });
  }

  function init() {
    var placeholders = document.querySelectorAll('[data-sp-related]');
    if (!placeholders.length) return;
    Array.prototype.forEach.call(placeholders, loadRelated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
